import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CardType } from './card-type.model';
import { CardTypeService } from './card-type.service';
import { CARD_UNLIMITED_BOOKINGS_NUMBER } from '../../shared';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class CardTypePopupService {
    private isOpen = false;
    private defaultIsEnrollment = false;
    private defaultAcceptOnlinePayments = false;
    private defaultUnlimitedClasses = false;

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private cardTypeService: CardTypeService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.cardTypeService.find(id).subscribe(cardType => {
                cardType.unlimitedClasses = cardType.maxAssistancesNum >= CARD_UNLIMITED_BOOKINGS_NUMBER;
                this.cardTypeModalRef(component, cardType);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        } else {
            let c: CardType = new CardType();
            c.package_ = this.defaultIsEnrollment;
            c.unlimitedClasses = this.defaultUnlimitedClasses;
            c.acceptOnlinePayments = this.defaultAcceptOnlinePayments;
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.cardTypeModalRef(component, c);
            });
        }
    }

    cardTypeModalRef(component: Component, cardType: CardType): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.cardType = cardType;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type-popup.service.ts